import type { ReactNode } from "react";
import { Logo } from "@/components/shell/Logo";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";

type LoginCardProps = {
  title?: string;
  subtitle?: string;
  children?: ReactNode;
  className?: string;
};

/** Login shell aligned with c456-aio FullPageCard (without Card ui dependency). */
export function LoginCard({
  title,
  subtitle,
  children,
  className = "w-full max-w-md",
}: LoginCardProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <div className={cn("mx-auto", className)}>
        <div className="flex items-center justify-center">
          <Logo />
        </div>
        <div className="my-8 rounded-xl border border-border bg-card text-card-foreground shadow-sm">
          {(title || subtitle) && (
            <div className="space-y-1.5 px-6 pt-6 text-center">
              {title ? <h1 className="text-xl font-semibold tracking-tight">{title}</h1> : null}
              {subtitle ? <p className="text-sm text-muted-foreground">{subtitle}</p> : null}
            </div>
          )}
          {children ? (
            <>
              {(title || subtitle) && <Separator className="mt-6" />}
              <div className={title || subtitle ? "px-6 pt-6 pb-8" : "flex flex-col items-center space-y-6 px-12 py-4"}>
                {children}
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
